/* ============================================================
   Защитный слой вокруг lazy-виджета ЧМ. Импортируется СТАТИЧЕСКИ
   (живёт в основном бандле, ничего из виджета не тянет): если
   чанк виджета упал при загрузке/выполнении на экзотическом
   устройстве — вместо пустоты рендерится статичная полоска-ссылка
   на промо-страницу (обычная <a>, ноль JS), а ошибка уходит в
   console.error с префиксом [WC-WIDGET] для отладки.
   ============================================================ */
import React from "react";

const stripStyle = {
  display: "block",
  margin: "20px auto",
  maxWidth: "1200px",
  padding: "14px 20px",
  borderRadius: "12px",
  border: "1px solid #e2e5eb",
  background: "#fff",
  color: "#202020",
  fontFamily: "'Rubik', sans-serif",
  fontSize: "15px",
  fontWeight: 500,
  textDecoration: "none",
  textAlign: "center",
};

export default class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("[WC-WIDGET] widget crashed, rendering fallback strip", error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <a style={stripStyle} href="/#worldcup">
          Чемпионат Мира 2026 — участвовать
        </a>
      );
    }
    return this.props.children;
  }
}
